import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Loader.styles'

/**
 * Loading Animation Component
 */
const Loader = (props) => {
  const { variant, size, displayType, children, showOverlay, ...rest } = props

  const loaderClasses = `lazy-loading  lazy-loading--${ size } ${
    variant === 'error' ? 'error' : ''
  }`

  // if overlay is used, the lazy loading logic gets wrapped
  if (displayType === 'overlay') {
    return (
      <Component.LoadingOverlay
        className='loading-overlay'
        showOverlay={ showOverlay }
        aria-live='polite'
        { ...rest }>
        <div className='lazy-loading'>
          <div className='lazy-loading__icon' />
          <p> {children}</p>
        </div>
      </Component.LoadingOverlay>
    )
  }

  return (
    <Component.Loader className={ loaderClasses } aria-live='polite' { ...rest }>
      <div>
        <div className='lazy-loading__icon' />
        <p>{children}</p>
      </div>
    </Component.Loader>
  )
}

Loader.defaultProps = {
  size: 'big',
  displayType: 'inline',
  showOverlay: false,
}

Loader.propTypes = {
  // show loading or loading error state
  variant: PropTypes.oneOf(['loading', 'error']).isRequired,
  // size variants
  size: PropTypes.oneOf(['small', 'medium', 'big']),
  // show loader wrapped in an overlay or inline
  displayType: PropTypes.oneOf(['overlay', 'inline']),
  // toggles overlay if display type is set accordingly used only in connection with displayType: overlay
  showOverlay: PropTypes.bool,
}

export default Loader
